// Language configurations
export const LANGUAGES = [
  { name: "English", code: "en" },
  { name: "Bengali", code: "bn" },
  { name: "Spanish", code: "es" },
  { name: "Hindi", code: "hi" },
  { name: "French", code: "fr" },
  { name: "German", code: "de" },
  { name: "Japanese", code: "ja" },
  { name: "Arabic", code: "ar" }
];

// Learning skill levels with specific roadmap structures
export const SKILL_LEVELS = [
  { 
    name: "Beginner", 
    level: "Foundation", 
    icon: "ShieldCheck",
    description: "Basic concepts + full overview of the skill",
    structure: "Fundamentals and overview only"
  },
  { 
    name: "Intermediate", 
    level: "Applied", 
    icon: "Activity",
    description: "All basics + intermediate concepts + career prep (last 3 days)",
    structure: "Core knowledge + Last 3 days: Internships, jobs, and interview preparation"
  },
  { 
    name: "Expert", 
    level: "Mastery", 
    icon: "BrainCircuit",
    description: "A-Z comprehensive knowledge + job expertise (last 7 days)",
    structure: "Complete mastery + Last 7 days: Job preparation and expertise development"
  }
];

// Backwards compatibility
export const INTENSITIES = SKILL_LEVELS;

// Local storage keys
export const STORAGE_KEYS = {
  ROADMAPS: 'nanolez_v4_roadmaps',
  ARTICLES: 'nanolez_v4_articles',
  THEME: 'nanolez_theme',
  LANGUAGE: 'nanolez_language',
  INTENSITY: 'nanolez_intensity'
};

// Verified educational platforms
export const VERIFIED_EDUCATIONAL_PLATFORMS = {
  programming: [
    'https://developer.mozilla.org',
    'https://www.freecodecamp.org',
    'https://javascript.info',
    'https://web.dev',
    'https://css-tricks.com',
    'https://www.w3schools.com',
    'https://www.codecademy.com',
    'https://www.smashingmagazine.com',
    'https://www.tutorialspoint.com',
    'https://scrimba.com',
    'https://frontendmasters.com',
    'https://www.theodinproject.com'
  ],
  dataScience: [
    'https://www.kaggle.com/learn',
    'https://pandas.pydata.org/docs/',
    'https://numpy.org/doc/',
    'https://scikit-learn.org/stable/',
    'https://www.dataquest.io',
    'https://www.coursera.org/browse/data-science',
    'https://www.edx.org/learn/data-science',
    'https://www.datacamp.com',
    'https://towardsdatascience.com',
    'https://jovian.ai',
    'https://colab.research.google.com'
  ],
  general: [
    'https://www.coursera.org',
    'https://www.edx.org',
    'https://www.khanacademy.org',
    'https://www.udemy.com',
    'https://www.youtube.com/c/freecodecamp',
    'https://www.youtube.com/c/ProgrammingwithMosh',
    'https://www.youtube.com/user/thenewboston',
    'https://www.sattacademy.com',
    'https://www.brilliant.org',
    'https://www.skillshare.com',
    'https://www.linkedin.com/learning',
    'https://www.mitocw.riku.com'
  ]
};

// Known good domains for URL validation
export const KNOWN_GOOD_DOMAINS = [
  'developer.mozilla.org', 'freecodecamp.org', 'w3schools.com', 'javascript.info',
  'css-tricks.com', 'web.dev', 'tutorialspoint.com', 'codecademy.com',
  'kaggle.com', 'pandas.pydata.org', 'numpy.org', 'scikit-learn.org',
  'coursera.org', 'edx.org', 'khanacademy.org', 'udemy.com',
  'youtube.com', 'youtu.be'
];

// Theme classes
export const THEME_CLASSES = {
  light: {
    bg: 'bg-gradient-to-br from-slate-50 to-blue-50',
    surface: 'bg-white',
    text: 'text-slate-900',
    muted: 'text-slate-500',
    border: 'border-slate-200',
    card: 'bg-white border border-slate-200',
    hover: 'hover:bg-slate-50'
  },
  dark: {
    bg: 'bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900',
    surface: 'bg-slate-800',
    text: 'text-slate-50',
    muted: 'text-slate-400',
    border: 'border-slate-700',
    card: 'bg-slate-800 border border-slate-700',
    hover: 'hover:bg-slate-700'
  }
};
